import styled from "styled-components";


export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0px;
    z-index: 1;
`
export const Logo = styled.img`
    max-width: 188px;
    @media screen and (max-width: 480px){
        max-width: 100px;
    }
`
export const ButtonIntegrador = styled.a`
    background-color: #056731;
    border-radius: 8px;
    padding: 14px 24px;
    color: #ffffff !important;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    
    @media screen and (max-width: 480px){
        background-color: #ffffff;
        color: #056731 !important;
        justify-content: center;

    }
`
export const Navigation = styled.nav`
    ul{
        padding: 0;
        margin: 0;
        li{
            display: inline-block;
            list-style: none;
            margin: 0px 20px;
            a{
                color: #464646;
                font-size: 16px;
                font-weight: 400;
                text-decoration: none;
            }
        }
    }
    @media screen and (max-width: 480px){
        position: absolute;
        right: 0;
        top: 64px;
        background-color: #056731;
        width: 100%;
        z-index: 9;
        transition: 0.3s;
        display: ${(props) => props.controlMenu };
        z-index: 9999;
        ul{
            padding: 0px 50px;
            li{
                display: block;
                text-align: center;
                margin: 15px 0px;
                a{
                    color: #ffffff;
                    text-align: center;
                }
            }
        }
    }
`
export const CallToAction = styled.div`
    display: flex;
    align-items: center;
    button{
        background-color: transparent;
        border: 0;
        color: #464646;
        margin-right: 15px;
    }
    a{
        background-color: #056731;
        border-radius: 8px;
        padding: 14px 24px;
        color: #ffffff;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }
`
export const ButtonMenuMobile = styled.button`
    background-color: transparent;
    color: #000000;
    font-size: 20px;
    border: 0;
`